"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../../foundations");
const TextV2_1 = require("../../../foundations/Typography/TextV2");
const DropdownItem_1 = require("./DropdownItem");
const useDynamicDropdownHeight_1 = require("./hooks/useDynamicDropdownHeight");
const DropdownItemList = ({ dropdownOptions, focusedIdx }) => {
    if (!dropdownOptions.length) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, dropdownOptions.map((option, idx) => (react_1.default.createElement(DropdownItem_1.DropdownItem, { key: option.value, option: option, isFocused: focusedIdx === idx, idx: idx })))));
};
const DropdownMenu = ({ dropdownOptions, showNoResults, optionDisplayCount = 5, focusedIdx, noResultsMessage, sx }) => {
    const dropdownRef = react_1.default.useRef(null);
    // Hook to dynamically adjust the height of the dropdown
    const { handleScroll } = (0, useDynamicDropdownHeight_1.useDynamicDropdownHeight)({
        dropdownOptions,
        dropdownRef,
        optionDisplayCount,
        showNoResults
    });
    if (!dropdownOptions.length && !showNoResults) {
        return null;
    }
    return (react_1.default.createElement(foundations_1.Box, { sx: Object.assign({ width: "100%", position: "absolute", zIndex: "dropdown", pt: "spacing-2", pb: "spacing-2", top: "100%", left: 0, border: "1px solid", borderColor: "input-stroke-enabled", borderRadius: "radius-2", backgroundColor: "input-onSurface", boxShadow: "shadow-100", transition: "opacity 200ms ease-out, transform 200ms ease-out, visibility 200ms" }, sx) }, dropdownOptions.length > 0 ? (react_1.default.createElement(foundations_1.Box, { ref: dropdownRef, as: "ul", sx: {
            listStyle: "none",
            overflowY: "auto"
        }, onScroll: handleScroll },
        react_1.default.createElement(DropdownItemList, { dropdownOptions: dropdownOptions, focusedIdx: focusedIdx }))) : (showNoResults && (react_1.default.createElement(foundations_1.Box, { sx: { px: "spacing-4", py: "spacing-5", textAlign: "center" } },
        react_1.default.createElement(TextV2_1.TextV2, { variant: "body-1-regular", sx: { color: "text-incidental" } }, noResultsMessage))))));
};
exports.DropdownMenu = DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map